import { useAppState } from 'AppProvider';
import { ITextFieldProps } from 'components/common/TextFieldInput/TextFieldInput';
import React, { useState } from 'react';
import {
  validateIsEmptyAndPhoneNumber,
  validatePhoneRequired,
} from 'utils/validators';
import PhoneNumberController from '../PhoneNumber/PhoneNumberController';

interface IPhoneFieldProps extends ITextFieldProps {
  scope: string;
}

// @deprecated we are using BookingPhoneField instead
const BookingPhone = ({ scope, name, label, ...props }: IPhoneFieldProps) => {
  const { experienceSettings: settings } = useAppState(
    (state: Record<string, unknown>) => state.experience,
  );
  const [telephoneCountryCode, setTelephoneCountryCode] = useState<string>('');
  const isCurrentScope = settings?.scope === scope;

  const getFieldsConfig = (config: string) => {
    if (!settings || !settings.fields) {
      return false;
    }
    return settings.fields.phoneNumber[config] ?? false;
  };

  const isFieldIncluded = getFieldsConfig('isActive');

  const phoneValidationPattern = () => {
    const isRequired = getFieldsConfig('isRequired');
    return {
      ...(isCurrentScope && isRequired && { ...validatePhoneRequired() }),
    };
  };

  if (!isCurrentScope && scope === 'participant') {
    return null;
  }

  if (isCurrentScope && !isFieldIncluded) {
    return null;
  }

  const { required } = phoneValidationPattern();

  return (
    <PhoneNumberController
      label={`${label}${required ? ':*' : ''}`}
      onTelephoneCountryCodeChange={setTelephoneCountryCode}
      name={name}
      rules={{
        ...validateIsEmptyAndPhoneNumber(required, telephoneCountryCode),
      }}
      telephoneCountryCode={telephoneCountryCode}
      {...props}
    />
  );
};

export default BookingPhone;
